/* eslint-disable wc/no-constructor-attributes */
/* eslint-disable max-classes-per-file */
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    if (!opener.classList.contains('quick-add__submit')) {
      document.body.classList.add('overflow-hidden')
    }
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    // eslint-disable-next-line wc/no-constructor-attributes
    const poster = this.querySelector('[id^="Deferred-Poster-"]')
    if (!poster) return
    poster.addEventListener('click', this.loadContent.bind(this))
  }

  loadContent(focus = true) {
    window.pauseAllMedia()
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      )

      this.setAttribute('loaded', true)
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      )
      if (focus) deferredElement.focus()
    }
  }
}

customElements.define('deferred-media', DeferredMedia)
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slide = this.slider.querySelector('.slideshow__slide');
    const clientWidth = slide ? slide.clientWidth : 0;
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      const videoBanner = item.closest('.video-banner')
      
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');

        if( videoBanner ){
          setTimeout(function(){
            const slide = videoBanner.querySelector(`.active_slide-${ index }`);
            if( slide ){
              slide.classList.add('is_active');
            }
          }, 300)
        }
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');

        if( videoBanner ){
          setTimeout(function(){
            const slide = videoBanner.querySelector(`.active_slide-${ index }`);
            if( slide ){
              slide.classList.remove('is_active');
            }
          }, 300)
        }
      }
    });
    
    this.sliderItemsToShow.forEach((item, index) => {
      if( item.closest('.video-banner') ){
        const videoBanner = item.closest('.video-banner');

        if (index === this.currentPage - 1) {
          const customBanners = videoBanner.querySelectorAll(`.video-banner_custom-slide`);
          customBanners.forEach(customBanner => {
            if( customBanner.classList.contains(`active_slide-${ index }`) ){
              customBanner.classList.add('is_active');
            } else {
              customBanner.classList.remove('is_active');
            }
          });
        }
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super()
    this.init()
    this.customSections = {
      productFreq: {
        id: 'productFreq',
      },
      productWhatsIncluded: {
        id: 'productWhatsIncluded',
      },
      customHR: {
        id: 'customHR',
      },
      productBenefits: {
        id: 'productBenefits',
      },
      productTabs: {
        id: 'productTabs',
      },
      productRecommendations: {
        id: 'productRecommendations',
      },
      productVariantCustomColorSwitcher: {
        id: 'productVariantCustomColorSwitcher',
      },
      productTrustBadges: {
        id: 'productTrustBadges',
      },
      productTabbedContent: {
        id: 'productTabbedContent',
      },
      productTitleWithImage: {
        id: 'productTitleWithImage',
      },
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    )
  }

  updateMasterId(event, callback = () => {}) {
    this.variantData = this.getVariantData()

    const selectedOptions = Array.from(this.querySelectorAll('select option[selected], fieldset input:checked'))
    const variantId = selectedOptions[0]?.dataset.variantId

    this.currentVariant = this.variantData.find((variant) => {
      return variant.id == variantId
    })

    if (this.variantData.length && this.variantData[0].isCombinedListing === true) {
      this.fetchUpdatedSection(event, callback.bind(this))
    } else {
      if (this.currentVariant === undefined) {
        this.currentVariant = this.variantData.find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option
            })
            .includes(false)
        })
        callback()
      } else {
        callback()
      }
    }
  }

  updateMedia() {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    )
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    )

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    )
    if (!modalContent) return
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    )
    modalContent.prepend(newMediaModal)
  }

  updateURL() {
    const url = this.currentVariant.option_value_id //Check if the variant belongs to combined listings
      ? `${this.currentVariant.url}?variant=${this.currentVariant.id}`
      : `${this.dataset.url}?variant=${this.currentVariant.id}`

    if (!this.currentVariant || this.dataset.updateUrl === 'false') return
    window.history.replaceState(
      {},
      '',
      `${ url }`
    )
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton || !shareButton.updateUrl) return
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      const stockQty = productForm.querySelector('input[name="stockQty"]')
      const bufferQty = productForm.querySelector('input[name="bufferQty"]')
    
      const continue_selling = this.currentVariant.inventory_policy
      const isPreorder = productForm.querySelector('input[name="properties[pre-order]"]')
      const preOrderModal = document.querySelector('.product-preorder-modal')
      const title = productForm.querySelector('input[name="title"]')

      if (this.currentVariant && input && stockQty && bufferQty) {
        input.value = this.currentVariant.id
        stockQty.value = this.currentVariant.stock
        bufferQty.value = this.currentVariant.buffer
        title.value = this.currentVariant.public_title
        input.dispatchEvent(new Event('change', { bubbles: true }))
      }

      if( this.currentVariant.pre_order_information == 'Yes' && continue_selling == 'continue'){
        if( isPreorder == null ){
          var preOrderInput = document.createElement('input');
          preOrderInput.type = 'hidden';
          preOrderInput.name = 'properties[pre-order]';
          preOrderInput.value = 'yes';
          preOrderInput.id = 'preOrder';

          input.parentNode.insertBefore(preOrderInput, input.nextSibling);
          preOrderModal.querySelector('.subtitle').innerHTML = this.currentVariant.stock_in_date;
          preOrderModal.setAttribute('open', '');
        } else {
          preOrderModal.querySelector('.subtitle').innerHTML = this.currentVariant.stock_in_date;
          preOrderModal.setAttribute('open', '');
        }
      } else {
        if( isPreorder != null ){
          isPreorder.remove()
        }
      }
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  removeErrorMessage() {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('product-form')
    if (productForm) productForm.handleErrorMessage()
  }

  renderProductTabs(source){
    const details = source.querySelectorAll('.tab-content');

    details.forEach((detail) => {
      if (detail && !detail.classList.contains('details--reviews')) {
        const { id } = detail
        const destination = document.getElementById(id)

        if (destination) {
          const destinationContent =
            destination.querySelector('.toggle-content')
          const detailContent = detail.querySelector('.toggle-content')

          if (destinationContent && detailContent) {
            destinationContent.innerHTML = detailContent.innerHTML
          }
        } else {
          // Optional: Log a message if the parent wasn't found
          console.error('Parent element not found. Cannot run querySelector.')
        }
      } else {
        const isActive = detail.querySelector('.is_active')

        if (isActive) {
          const sku = isActive.getAttribute('data-sku')
          const masterProducts = document.querySelectorAll('.master-product')

          masterProducts.forEach((element) => {
            element.classList.remove('is_active')
          })

          const activeVariants = document.querySelectorAll(
            `.master-product[data-sku="${sku}"]`
          )

          activeVariants.forEach((activeVariant) => {
            activeVariant.classList.add('is_active')
          })
        }
      }
    })

    const productTabs = document.querySelector('product-tabs')
    if (productTabs) {
      productTabs.handleProductFAQs()
    }
  }

  renderCustomSection(key, data) {
    const replaceSection = data
    const replaceSectionID = this.customSections[key].id
    const html = new DOMParser().parseFromString(replaceSection, 'text/html')
    const destination = document.getElementById(replaceSectionID)
    const source = html.getElementById(replaceSectionID)

    if (replaceSectionID === 'productTabs' && destination) {
      this.renderProductTabs(source)
    } else if (
      replaceSectionID === 'productVariantCustomColorSwitcher' &&
      destination
    ) {
      destination.innerHTML = source.outerHTML
    } else if (source && destination) {
      destination.innerHTML = source.innerHTML
    }
    if (destination) {
      destination.classList.remove('visibility-hidden')
    }
  }

  renderCustomSections() {
    const sections = Object.keys(this.customSections)
    if (this.responseText && this.responseText.length > 0) {
      sections.forEach((key) => {
        this.renderCustomSection(key, this.responseText)
      })
    } else {
      // fetching the page rather than using the sections schema as it is having issues with section_id vs sections and some somes sections are dynamic and others are static.
      if (!this.currentVariant || !this.currentVariant.url) return
      fetch(`${this.currentVariant.url}`)
        .then((response) => response.text())
        .then((sectionsJSON) => {
          sections.forEach((key) => {
            this.renderCustomSection(key, sectionsJSON)
          })
        })
    }
  }

  fetchProductInfo(responseText) {
    const html = new DOMParser().parseFromString(responseText, 'text/html')
    const updateIDs = ['price', 'id', 'inventory', 'stockInDate']

    updateIDs.forEach((id) => {
      const destination = document.getElementById(
        `${id}-${this.dataset.section}`
      )
      const source = html.getElementById(
        `${id}-${
          this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
        }`
      )
      if (source && destination) destination.innerHTML = source.innerHTML
      const el = document.getElementById(`${id}-${this.dataset.section}`)
      if (el) el.classList.remove('visibility-hidden')
    })

    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings.soldOut
    )
  }

  renderProductInfo() {
    if (this.responseText && this.responseText.length > 0) {
      this.fetchProductInfo(this.responseText)
    } else {
      if (!this.currentVariant) return
      const url = this.currentVariant.option_value_id //Check if the variant belongs to combined listings
      ? `${this.currentVariant.url}?option_values=${this.currentVariant.option_value_id}`
      : `${this.dataset.url}?variant=${this.currentVariant.id}`

      fetch(`
        ${url}&section_id=${
          this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
        }
      `)
        .then((response) => response.text())
        .then((responseText) => {
          this.fetchProductInfo(responseText) 
        })
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    )

    const newStockInfo = parseInt(productForm.querySelector('[name="stockQty"]').value)
    const newbufferStockInfo = parseInt(productForm.querySelector('[name="bufferQty"]').value)
    
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"] > span')
    if (!addButton) return

    if( this.currentVariant == undefined ){
      addButton.setAttribute('disabled', 'disabled')
      return
    }

    const newPreorderInformation = this.currentVariant.pre_order_information
    const continue_selling = this.currentVariant.inventory_policy 
    const isPreorder = newPreorderInformation == 'Yes' && continue_selling == 'continue'
    // console.log(newStockInfo);
    // console.log(newbufferStockInfo);

    if( isPreorder ){
      addButtonText.textContent = 'Pre-Order'
      addButton.removeAttribute('disabled')
      addButton.classList.add("button--pre-order");
    } else {
      if (disable || newStockInfo <= newbufferStockInfo) {
        addButton.setAttribute('disabled', 'disabled')
        if (text) addButtonText.textContent = text
      } else {
        addButton.removeAttribute('disabled')
        addButtonText.textContent = window.variantStrings.addToCart
      }
      addButton.classList.remove("button--pre-order");
    }

    if (!modifyClass) return

    // additional check done here to toggle the Notify me Button
    const backInStockDiv = document.getElementById("product__unavailable")

    if (!productForm) return
    const backInStockBtn = backInStockDiv?.querySelector('[name="backInStock"]')
    if (!backInStockBtn) return

    if( !isPreorder ){
      if (disable || newStockInfo <= newbufferStockInfo) {
        backInStockBtn.style.display = 'block'
        backInStockBtn.style.setProperty('--before-display', 'none')
        backInStockBtn.style.setProperty('--after-display', 'none')
      } else {
        backInStockBtn.style.display = 'none'
      }
    }
  }

  updateCardMedia() {
    const { featured_image: featuredImage } = this.currentVariant
    if (!featuredImage) return
    const sizes = [165, 360, 533, 720]
    const src =
      typeof featuredImage === 'string' ? featuredImage : featuredImage.src
    if (src === null || src === '') return
    const url = src.replace('https:', '')
    const img = this.card.querySelector('img')
    if (!img) return
    let srcset = ''
    sizes.forEach((size) => {
      srcset = `${srcset}${url}&width=${size} ${size}w, `
    })
    srcset = `${srcset} ${url} 800w`
    const imageSize = img.src.split('width=')[1]
    img.src = `${url}&width=${imageSize}`
    img.srcset = srcset
  }

  updateFormProduct() {
    const { id } = this.currentVariant
    const input = this.productForm.querySelector('input[name="id"]')
    if (input === null) return
    input.value = id
  }

  updateAddButton() {
    const { available } = this.currentVariant
    this.toggleAddButton(!available, window.variantStrings.soldOut)
  }

  updateCardPricing() {
    const priceEls = this.card.querySelectorAll('[data-price-id]')
    Array.from(priceEls).forEach((el) => {
      const { priceId } = el.dataset
      const newEl = new DOMParser().parseFromString(
        this.currentVariant[priceId],
        'text/html'
      ).body.firstElementChild
      el.replaceWith(newEl)
    })
  }

  updateCardTitle() {
    const { url } = this.currentVariant
    const el = this.card.querySelector('.card__heading a')
    // heading.textContent = title
    el.href = url
  }

  updateCardSKU() {
    const { sku } = this.currentVariant
    const el = this.card.querySelector('[data-id="sku"]')
    el.textContent = sku
  }

  updateStockInfo() {
    const stockInfoEl = this.card.querySelector('.stockinfo')
    if (!stockInfoEl) return

    const stock_in_date = this.currentVariant.stock_in_date
    if (stock_in_date) {
      stockInfoEl.innerHTML = `<span class="variant__stockinfo card__product-desc light caption-large" style="display: block;"><b>${stock_in_date}</b></span>`
      stockInfoEl.style.display = 'block'
    } else {
      stockInfoEl.innerHTML = ''
      stockInfoEl.style.display = 'none'
    }
  }

  updateQuickAdd() {
    const html = new DOMParser().parseFromString(this.responseText, 'text/html')
    const destination_variantSelector = this.card.querySelector('.quick-add-product-form .selector-type')
    const source_variantSelector = html.querySelector(`.product .variant-picker`)

    if (source_variantSelector && destination_variantSelector) destination_variantSelector.innerHTML = source_variantSelector.innerHTML

    this.updateAddButton()
  }

  updateGalleryGrid() {
    if (!this.currentVariant) return
    const galleryGrid = document.getElementById('productGalleryGrid')
    if (!galleryGrid) return

    const { altMatch, activeVariant: previousVariant } = galleryGrid.dataset
    if (!altMatch) return

    const productTitle = this.currentVariant.name || this.currentVariant.title || ''
    const activeVariant = productTitle.includes(altMatch) ? 'alt' : 'primary'

    if (previousVariant && previousVariant !== activeVariant) {
      galleryGrid
        .querySelectorAll(
          `.gallery-grid__item[data-media-variant="${previousVariant}"]`
        )
        .forEach((outgoing) => {
          const { nextElementSibling, previousElementSibling } = outgoing
          let incoming = null
          if (nextElementSibling?.dataset.mediaVariant === activeVariant) {
            incoming = nextElementSibling
          } else if (previousElementSibling?.dataset.mediaVariant === activeVariant) {
            incoming = previousElementSibling
          }
          if (!incoming) return
          outgoing.style.setProperty('height', 'auto')
          incoming.style.height = `${outgoing.offsetHeight}px`
        })
    }

    galleryGrid.setAttribute('data-active-variant', activeVariant)
  }

  updatePDP() {
    this.updateMedia()
    this.updateGalleryGrid()
    this.updateURL()
    this.renderProductInfo()
    this.updateShareUrl()
    this.renderCustomSections()
    this.updatePickupAvailability()
  }

  updateCard() {
    this.updateCardMedia()
    this.updateQuickAdd()
    this.updateCardPricing()
    this.updateCardTitle()
    this.updateCardSKU()
    this.updateStockInfo()
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    )
    const addButton = button.querySelector('[name="add"]')
    const addButtonText = button.querySelector('[name="add"] > span')
    const price = document.getElementById(`price-${this.dataset.section}`)
    if (!addButton) return
    addButtonText.textContent = window.variantStrings.unavailable
    if (price) price.classList.add('visibility-hidden')
  }

  getVariantData() {
    return JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    )
  }

  variantChangeCallback() {
    this.removeErrorMessage()
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateVariantInput()
      this.updateVariantDescription(this.currentVariant)
      if (!this.isCard) {
        this.updatePDP()
        this.toggleAddButton(false, '', false)
      } else {
        this.updateCard()
      }
    }
  }

  onVariantChange(event) {
    this.card = this.card || this.closest('.card-wrapper')
    this.isCard = !!this.card
    this.isInstallBundle = this.closest('.featured-bundle')

    this.updateOptions()
    this.updateMasterId(event, this.variantChangeCallback.bind(this))
  }

  updateVariantDescription(currentVariant) {
    // Find all the variant descriptions with the data attribute that we added
    const variants = document.querySelectorAll('[data-variant-id]')

    variants.forEach((variant) => {
      //hide all variant descriptions
      variant.style.display = 'none'
      if(variant.dataset.variantId == currentVariant.id){
        //if current variant unhide the variant description
        variant.style.display = 'block'
      }
    })
  }

  getIsCard() {
    if (this.dataset.section.includes('quick-add')) {
      return true
    }
    return false
  }

  /**
   * Re-renders the variant picker.
   * @param {Document} newHtml - The new HTML.
   * @returns {NewProduct | undefined} Information about the new product if it has changed, otherwise undefined.
   */
  updateVariantPicker(newHtml) {
    /** @type {NewProduct | undefined} */
    let newProduct

    const newVariantPickerSource = newHtml.querySelector(
      this.tagName.toLowerCase()
    )

    if (!newVariantPickerSource) {
      throw new Error('No new variant picker source found')
    }

    // For combined listings, the product might have changed, so update the related data attribute.
    if (newVariantPickerSource instanceof HTMLElement) {
      const newProductId = newVariantPickerSource.dataset.productId
      const newProductUrl = newVariantPickerSource.dataset.productUrl

      if (newProductId && newProductUrl && this.dataset.productId !== newProductId) {
        newProduct = { id: newProductId, url: newProductUrl }
      }

      this.dataset.productId = newProductId
      this.dataset.productUrl = newProductUrl
    }

    return newProduct
  }

  get selectedOptionsValues() {
    /** @type HTMLElement[] */
    const selectedOptions = Array.from(this.querySelectorAll('select option[selected], fieldset input:checked'))

    return selectedOptions.map((option) => {
      const { optionValueId } = option.dataset

      if (!optionValueId) throw new Error('No option value ID found')

      return optionValueId
    });
  }

  buildRequestUrl(selectedOption, source = null, sourceSelectedOptionsValues = []) {
    let productUrl = selectedOption.dataset.connectedProductUrl || this.dataset.productUrl
    const params = []
    if (this.selectedOptionsValues.length && !source) {
      params.push(`option_values=${this.selectedOptionsValues.join(',')}`)
    } 

    return `${productUrl}?${params.join('&')}`
  }

  fetchUpdatedSection(event, callback = () => {}) {
    if (!(event.target instanceof HTMLElement)) return

    const selectedOption =
      event.target instanceof HTMLSelectElement ? event.target.options[event.target.selectedIndex] : event.target

    if (!selectedOption) return

    // Morph the entire main content for combined listings child products, because changing the product
    // might also change other sections depending on recommendations, metafields, etc.
    const currentUrl = this.dataset.productUrl?.split('?')[0]
    const newUrl = selectedOption.dataset.connectedProductUrl
    const loadsNewProduct = !!newUrl && newUrl !== currentUrl

    if( loadsNewProduct ){
      this.toggleAddButton(true, '', false)
      fetch(this.buildRequestUrl(selectedOption))
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          // Defer is only useful for the initial rendering of the page. Remove it here.
          html.querySelector('overflow-list[defer]')?.removeAttribute('defer')

          const textContent = html.querySelector(`product-radios script[type="application/json"]`)?.textContent

          if (!textContent) return
          const data = event.target.closest('product-radios').querySelector('script[type="application/json"]')
          if (data) {
            data.innerHTML = ''
            data.textContent = textContent
          }

          const variantData = this.getVariantData() || []
          this.currentVariant = variantData[0]
          this.responseText = responseText

          this.dataset.productUrl = newUrl

          callback()
        })
        .catch((error) => { 
          if (error.name === 'AbortError') {
            console.warn('Fetch aborted by user')
          } else {
            console.error(error)
          }
        });
    }
  }

  init() {
    this.addEventListener('change', this.onVariantChange.bind(this))
    this.variantData = this.getVariantData(this)
    this.pdp = document.querySelector('[data-id="MainProduct"]')
    this.isCard = this.getIsCard()
  }
}

customElements.define('variant-selects', VariantSelects)

// eslint-disable-next-line no-undef
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

/* eslint-disable no-console */
// eslint-disable-next-line no-undef
class ProductSelects extends VariantSelects {
  constructor() {
    super()
    this.isMaster = 'false'
    this.initProduct()
  }

  updateMedia() {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    )
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    )

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    )
    if (!modalContent) return
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    )
    modalContent.prepend(newMediaModal)
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return
    window.history.replaceState({}, '', `${this.currentVariant.url}`)
  }

  fetchProductData(responseText) {
    const { originalSection, section } = this.dataset
    
    const html = new DOMParser().parseFromString(responseText, 'text/html')
    const replace = [
      'MediaGalleryWrapper',
      'id',
      'price',
      'product-description',
      'product-text',
      'product-description-short',
      'title',
      'Details-bulk',
      'VariantSelectors-product-form',
      'buy-buttons',
      'inventory',
    ]

    replace.forEach((key) => {
      const destination = document.getElementById(`${key}-${section}`)

      const source = html.getElementById(
        `${key}-${originalSection || section}`
      )
      if (source && destination) destination.innerHTML = source.innerHTML
      const el = document.getElementById(`${key}-${section}`)
      if (el) el.classList.remove('visibility-hidden')
    })
    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings.soldOut
    )
  }

  renderProductInfo() {
    const { originalSection, section } = this.dataset

    if (this.responseText && this.responseText.length > 0) {
      this.fetchProductData(this.responseText)
    } else {
      fetch(
        `${this.currentVariant.url}?&section_id=${originalSection || section}`
      )
        .then((response) => response.text())
        .then((responseText) => {
          this.fetchProductData(responseText)
        })
        .catch((error) => console.error(error))
    }
  }

  updateInventory(html) {
    const id = `inventory-${this.dataset.section}`
    const destination = document.getElementById(id)
    const source = html.getElementById(id)
    if (source && destination) destination.innerHTML = source.innerHTML
  }

  updateCardTitle() {
    const { url, title } = this.currentVariant
    const heading = this.card.querySelector('.card__heading a')
    heading.textContent = title
    heading.href = url
  }

  adjustSelected() {
    const radios = this.querySelectorAll('input[type=radio]')
    const selectedInputs = Array.from(radios).filter(({ checked }) => checked)
    const selectedOptions = Array.from(selectedInputs).map(({ value }) => value)
    const { options } = this.currentVariant
    if (
      options.length === selectedOptions.length &&
      !options.every((v, i) => v === selectedOptions[i])
    ) {
      this.removeEventListener('change', this.onVariantChange)
      Array.from(radios)
        .filter(({ checked }) => !checked)
        .forEach((radio) => {
          if (options.includes(radio.value)) {
            // eslint-disable-next-line no-param-reassign
            radio.checked = true
          }
        })
      this.addEventListener('change', this.onVariantChange)
    }
  }

  initProduct() {
    const { pathname } = window.location
    const { selectorUrl } = this.dataset
    const testURL = this.isCard ? selectorUrl : pathname
    let currentVariant = this.variantData.find(({ url }) => testURL === url )
    if (!currentVariant) {
      // eslint-disable-next-line prefer-destructuring
      currentVariant = this.variantData[0]
    }
    this.currentVariant = currentVariant
    let isMaster = 'false'
    if (this.isCard) {
      isMaster = this.dataset.isMaster
    } else {
      isMaster = this.pdp?.dataset.isMaster
    }
    this.adjustSelected()
    if (isMaster === 'true') {
      this.updateOptions()
      this.updateMasterId()
      this.toggleAddButton(true, '', false)
      if (!this.isCard) {
        this.updatePDP()
      } else {
        // this.updateCard()
      }
      this.dataset.isMaster = 'false'
      if (this.pdp) {
        this.pdp.isMaster = 'false'
      }
    }
  }
}

customElements.define('product-selects', ProductSelects)

// eslint-disable-next-line no-undef
class ProductRadios extends ProductSelects {
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value
    })
  }
}

customElements.define('product-radios', ProductRadios)

// eslint-disable-next-line no-undef
class FeaturedProductSlideshow extends HTMLElement {
  constructor() {
    super()
    this.init()
    if (!this.slider || !this.nextButton) return
    this.addEventListeners()
    this.toggleButtons()
  }

  addEventListeners() {
    // const resizeObserver = new ResizeObserver(entries => this.initPages());
    // resizeObserver.observe(this.slider)
    this.slider.addEventListener('scroll', this.onScroll.bind(this), 300)
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this))
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this))
  }

  canScrollRight() {
    return (
      this.slider.scrollLeft + Math.round(this.getBoundingClientRect().width) <
      this.slider.scrollWidth
    )
  }

  canScrollLeft() {
    const currentItem = this.sliderItems[this.currentSlideIndex]
    const offset =
      currentItem.getBoundingClientRect().width -
      (this.getBoundingClientRect().left -
        currentItem.getBoundingClientRect().left)
    return (
      this.slider.scrollLeft > 0 &&
      (this.slider.scrollLeft + offset >=
        currentItem.getBoundingClientRect().width +
          this.sliderItemFirst.offsetLeft ||
        this.currentSlideIndex !== 0)
    )
  }

  toggleButtons() {
    if (this.canScrollRight()) {
      this.toggleButton(this.nextButton, false)
    } else {
      this.toggleButton(this.nextButton, true)
    }
    if (this.canScrollLeft()) {
      this.toggleButton(this.prevButton, false)
    } else {
      this.toggleButton(this.prevButton, true)
    }
  }

  // eslint-disable-next-line class-methods-use-this
  toggleButton(button, disable) {
    if (disable) {
      button.setAttribute('disabled', 'disabled')
    }
    if (!disable) {
      button.removeAttribute('disabled')
    }
  }

  getNextSlideIndexFromDirection(direction = 'none') {
    const current = this.currentSlideIndex
    if (direction === 'none') {
      return current
    }
    const nextIndex = direction === 'left' ? current - 1 : current + 1
    if (!(nextIndex >= 0 && nextIndex <= this.maxPositions)) {
      return current
    }
    return nextIndex
  }

  onButtonClick(event) {
    event.preventDefault()
    const { currentTarget } = event
    const { name } = currentTarget
    const nextIndex = this.getNextSlideIndexFromDirection(
      name === 'next' ? 'right' : 'left'
    )
    this.slider.scrollLeft = this.sliderItems[nextIndex].offsetLeft
  }

  getScrollChange() {
    return Math.abs(this.currentPosition - this.slider.scrollLeft)
  }

  getScrollDirection() {
    if (this.slider.scrollLeft > this.currentPosition) {
      return 'right'
    }
    if (this.slider.scrollLeft === this.currentPosition) {
      return 'none'
    }
    return 'left'
  }

  getNextSlideIndex() {
    const { scrollLeft } = this.slider
    let newIndex = this.getNextSlideIndexFromDirection(
      this.getScrollDirection()
    )
    if (this.canScrollLeft() && !this.canScrollRight()) {
      newIndex = this.maxPositions
    } else if (!this.canScrollLeft() && this.canScrollRight()) {
      newIndex = 0
    } else {
      newIndex = this.scrollPositions.findIndex((position, index) => {
        const next = index + 1
        const start = position
        const greaterThanStart = start >= scrollLeft
        const end =
          next !== this.scrollPositions.length
            ? position + this.scrollPositions[next]
            : this.slider.scrollWidth
        const lessThanEnd = scrollLeft < end
        return greaterThanStart && lessThanEnd
      })
    }
    return newIndex
  }

  onScrollStop() {
    this.currentPosition = this.slider.scrollLeft
    this.currentSlideIndex = this.getNextSlideIndex()
    this.toggleButtons()
  }

  onScroll() {
    // Clear our timeout throughout the scroll
    window.clearTimeout(this.isScrolling)

    // Set a timeout to run after scrolling ends
    this.isScrolling = setTimeout(this.onScrollStop.bind(this), 150)
  }

  init() {
    this.slider = this.querySelector('[id^="Slider-"]')
    this.lastScrollLeft = 0
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
    // eslint-disable-next-line prefer-destructuring
    this.sliderItemFirst = this.sliderItems[0]
    this.sliderItemLast = this.sliderItems[this.sliderItems.length - 1]
    this.sliderItemFirstWidth =
      this.sliderItemFirst.getBoundingClientRect().width
    this.sliderItemLastWidth = this.sliderItemLast.getBoundingClientRect().width
    this.prevButton = this.querySelector('button[name="previous"]')
    this.nextButton = this.querySelector('button[name="next"]')
    this.visible = this.slider.dataset.visible
      ? Number(this.slider.dataset.visible)
      : 1
    this.currentSlideIndex = 0
    this.currentPosition = 0
    this.slideItemsCount = this.sliderItems.length
    this.maxPositions = this.slideItemsCount - this.visible
    this.isScrolling = false
    this.scrollPositions = Array.from(this.sliderItems).map(
      (slide) => slide.offsetLeft
    )
  }
}

customElements.define('featured-product-slideshow', FeaturedProductSlideshow)

function ourSystemTabs() {
  const section = document.getElementById('ourSystem')
  if (section === null) {
    return
  }
  const slideShow = document.getElementById('ourSystemSlideshow')
  const scroller = document.getElementById('ourSystemSlider')
  const scrollerList = scroller.querySelector('ul')
  const points = section.querySelectorAll('.our-system__point--tab')
  const tabs = section.querySelectorAll('.our-system__tab')
  const mobileTabs = Array.from(tabs).filter(
    (tab) => !tab.classList.contains('is-hidden-mobile')
  )
  const desktopMediaQuery = '(min-width: 750px)'
  const mediaQuery = window.matchMedia(desktopMediaQuery)
  if (tabs.length === 0 || points.length === 0) {
    return
  }

  const isTab = (el) => el.classList.contains('our-system__tab')
  const isPoint = (el) => el.classList.contains('our-system__point')
  const isActive = (el) => el.classList.contains('is-active')

  function deactiveTab(tab) {
    const card = tab.querySelector('.our-system__card')
    if (isActive(card)) {
      card.classList.remove('is-active', 'color-brand-light-green')
    }
  }

  function deactivePoint(point) {
    if (isActive(point)) {
      point.classList.remove('is-active')
    }
  }

  function activateTab(tab, scrollToTab = false) {
    if (scrollToTab) {
      const tabLeft = tab.offsetLeft
      const list = tab.parentElement
      scrollerList.scrollIntoView(false)
      setTimeout(() => {
        list.scrollTo({
          left: tabLeft,
        })
      }, '300')
    }
    const card = tab.querySelector('.our-system__card')
    const otherTabs = Array.from(tabs).filter((el) => el !== tab)
    if (!isActive(card)) {
      card.classList.add('is-active', 'color-brand-light-green')
    }
    otherTabs.forEach((otherTab) => deactiveTab(otherTab))
  }

  function activatePoint(point) {
    const otherPoints = Array.from(points).filter((el) => el !== point)
    if (!isActive(point)) {
      point.classList.add('is-active')
    }
    otherPoints.forEach((otherPoint) => deactivePoint(otherPoint))
  }

  function onClick(evt) {
    const { target } = evt
    let li = target
    if (target.tagName === 'A') {
      return
    }
    evt.preventDefault()
    if (target.tagName !== 'LI') {
      li = target.closest('li')
    }
    let index = 0
    if (isTab(li)) {
      index = Array.from(tabs).indexOf(li)
    }
    if (isPoint(li)) {
      index = Array.from(points).indexOf(li)
    }
    const tab = tabs[index]
    activateTab(tab, true)
    const point = points[index]
    activatePoint(point, true)

  }

  function onHover(evt) {
    const { target } = evt
    const elClass = 'is-visible'
    target.classList.remove(elClass)
  }

  const observePoints = new IntersectionObserver((evt) => {
    evt.forEach((observeEvent) => {
      const { isIntersecting, target } = observeEvent
      const elClass = 'is-visible'
      if (isIntersecting) {
        target.classList.add(elClass)
      } else {
        target.classList.remove(elClass)
      }
    })
  })

  function onSlideChange(evt) {
    if (mediaQuery.matches) {
      return
    }
    const index = evt.detail.currentPage - 1
    activateTab(mobileTabs[index])
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', (evt) => onClick(evt))
  })

  points.forEach((point) => {
    point.addEventListener('click', (evt) => onClick(evt))
    const counter = point.querySelector('.our-system__counter')
    if (counter) {
      observePoints.observe(counter)
    }
    counter.addEventListener('mouseover', (evt) => onHover(evt))
  })
  slideShow.addEventListener('slideChanged', (evt) => onSlideChange(evt))
  mediaQuery.onchange = () => activateTab(tabs[0])
}
ourSystemTabs()

;(function mediaQuotes() {
  const dataId = '[data-section-id="media-quotes"]'
  const sections = document.querySelectorAll(dataId)
  const sectionsData = Array.from(sections).reduce(
    (object, section) => ({
      ...object,
      [section.id]: {
        timeout: false,
      },
    }),
    {}
  )

  function toggleActive(section) {
    const triggers = section.querySelectorAll(`details`)
    const maxIndex = triggers.length - 1
    const index = Array.from(triggers).findIndex((el) => el.open === true)
    const nextIndex = index >= maxIndex ? 0 : index + 1
    const currentEl = triggers[index]
    const nextEl = triggers[nextIndex]
    if (currentEl) {
      currentEl.removeAttribute('open')
    }
    if (nextEl) {
      nextEl.setAttribute('open', '')
    }
    // eslint-disable-next-line no-use-before-define
    advanceQuote(section)
  }

  function advanceQuote(section) {
    const { speed = '0' } = section.dataset
    const advanceSpeed = Number(speed)
    if (advanceSpeed === 0) {
      return
    }
    sectionsData[section.id].timeout = setTimeout(() => {
      toggleActive(section)
    }, speed)
  }

  function onClick(evt, section) {
    const { target } = evt
    const openAttribute = 'open'
    if (target.open || target.nodeName !== 'SUMMARY') {
      evt.preventDefault()
      return
    }
    const openEl = section.querySelector(`details[${openAttribute}]`)
    if (!openEl) {
      return
    }
    openEl.open = false
  }

  function initSections() {
    if (sections === null || !sections.length) {
      return
    }
    Array.from(sections).forEach((section) => {
      const triggers = section.querySelectorAll(`details`)
      Array.from(triggers).forEach((trigger) => {
        sectionsData[section.id].timeout = false
        trigger.addEventListener('click', (evt) => {
          clearTimeout(sectionsData[section.id].timeout)
          sectionsData[section.id].timeout = false
          onClick(evt, section)
          advanceQuote(section)
        })
      })
      advanceQuote(section)
    })
  }

  initSections()
})()

class CartDrawer extends MenuDrawer {
  constructor() {
    super()

    this.triggers = document.querySelectorAll('[data-cart-toggle]')
    this.summary = this.querySelector('summary')
    this.addEventListeners()
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    )
  }

  addEventListeners() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault()
        this.forceClickTrigger()
      })
    })

    window.addEventListener('resize', () => {
      this.updateDrawerHeight()
    })
  }

  /**
   * need to expose this as a public method so it can be called from the product form
   */
  forceClickTrigger() {
    const elem = this.summary
    // Create our event (with options)
    const evt = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    })
    // If cancelled, don't dispatch our event
    const cancelled = !elem.dispatchEvent(evt)

  }

  updateDrawerHeight() {
    this.header = this.header || document.getElementById('shopify-section-header')
    if (!this.header) {
      return
    }
    const { bottom } = this.header.getBoundingClientRect()
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(bottom)}px` )
  }

  openMenuDrawer(summaryElement) {
    // these 3 lines have been borrowed from HeaderDrawer, but changed slightly
    this.header = this.header || document.getElementById('shopify-section-header')
    const headerWrapper = document.getElementById('headerWrapper')
    let summary = summaryElement
    if (!summaryElement){
      summary = this.querySelector('summary')
    }
    document.body.classList.add('overflow-hidden')
    this.borderOffset =
      this.borderOffset ||
      headerWrapper.classList.contains('header-wrapper--border-bottom')
        ? 1
        : 0

    this.updateDrawerHeight()
    document.body.classList.add('overflow-hidden')
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
      this.mainDetailsToggle.setAttribute('open', '')
    })
    this.header.classList.add('cart-drawer-open')
    this.classList.add('is-open')
    summary.setAttribute('aria-expanded', true)
    document.body.classList.add(`overflow-hidden`)
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.header.classList.remove('cart-drawer-open')
      this.classList.remove('is-open')
      this.mainDetailsToggle.classList.remove('menu-opening')
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open')
        details.classList.remove('menu-opening')
      })
      document.body.classList.remove(`overflow-hidden`)
      // summary is not our trigger, so no need to focus it
      // removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle)

    }
  }
}

customElements.define('cart-drawer', CartDrawer)

function r(n,t){for(var i=0;i<t.length;i++){var r=t[i];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(n,r.key,r)}}function Jt(n,t,i){t&&r(n.prototype,t),i&&r(n,i),Object.defineProperty(n,"prototype",{writable:!1})}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
var n,t;n=this,t=function(){"use strict";var v="(prefers-reduced-motion: reduce)",G=4,rn=5,r={CREATED:1,MOUNTED:2,IDLE:3,MOVING:G,SCROLLING:rn,DRAGGING:6,DESTROYED:7};function D(n){n.length=0}function o(n,t,i){return Array.prototype.slice.call(n,t,i)}function R(n){return n.bind.apply(n,[null].concat(o(arguments,1)))}function on(){}var p=setTimeout;function h(n){return requestAnimationFrame(n)}function u(n,t){return typeof t===n}function un(n){return!c(n)&&u("object",n)}var e=Array.isArray,x=R(u,"function"),C=R(u,"string"),en=R(u,"undefined");function c(n){return null===n}function m(n){try{return n instanceof(n.ownerDocument.defaultView||window).HTMLElement}catch(n){return!1}}function y(n){return e(n)?n:[n]}function g(n,t){y(n).forEach(t)}function b(n,t){return-1<n.indexOf(t)}function k(n,t){return n.push.apply(n,y(t)),n}function A(t,n,i){t&&g(n,function(n){n&&t.classList[i?"add":"remove"](n)})}function M(n,t){A(n,C(t)?t.split(" "):t,!0)}function L(n,t){g(t,n.appendChild.bind(n))}function O(n,i){g(n,function(n){var t=(i||n).parentNode;t&&t.insertBefore(n,i)})}function cn(n,t){return m(n)&&(n.msMatchesSelector||n.matches).call(n,t)}function S(n,t){n=n?o(n.children):[];return t?n.filter(function(n){return cn(n,t)}):n}function fn(n,t){return t?S(n,t)[0]:n.firstElementChild}var E=Object.keys;function w(t,i,n){t&&(n?E(t).reverse():E(t)).forEach(function(n){"__proto__"!==n&&i(t[n],n)})}function an(r){return o(arguments,1).forEach(function(i){w(i,function(n,t){r[t]=i[t]})}),r}function d(i){return o(arguments,1).forEach(function(n){w(n,function(n,t){e(n)?i[t]=n.slice():un(n)?i[t]=d({},un(i[t])?i[t]:{},n):i[t]=n})}),i}function sn(t,n){g(n||E(t),function(n){delete t[n]})}function P(n,i){g(n,function(t){g(i,function(n){t&&t.removeAttribute(n)})})}function I(i,t,r){un(t)?w(t,function(n,t){I(i,t,n)}):g(i,function(n){c(r)||""===r?P(n,t):n.setAttribute(t,String(r))})}function j(n,t,i){n=document.createElement(n);return t&&(C(t)?M:I)(n,t),i&&L(i,n),n}function _(n,t,i){if(en(i))return getComputedStyle(n)[t];c(i)||(n.style[t]=""+i)}function ln(n,t){_(n,"display",t)}function dn(n){n.setActive&&n.setActive()||n.focus({preventScroll:!0})}function z(n,t){return n.getAttribute(t)}function vn(n,t){return n&&n.classList.contains(t)}function N(n){return n.getBoundingClientRect()}function T(n){g(n,function(n){n&&n.parentNode&&n.parentNode.removeChild(n)})}function hn(n){return fn((new DOMParser).parseFromString(n,"text/html").body)}function F(n,t){n.preventDefault(),t&&(n.stopPropagation(),n.stopImmediatePropagation())}function pn(n,t){return n&&n.querySelector(t)}function gn(n,t){return t?o(n.querySelectorAll(t)):[]}function X(n,t){A(n,t,!1)}function mn(n){return n.timeStamp}function W(n){return C(n)?n:n?n+"px":""}var yn="splide",f="data-"+yn;function bn(n,t){if(!n)throw new Error("["+yn+"] "+(t||""))}var Y=Math.min,wn=Math.max,xn=Math.floor,kn=Math.ceil,U=Math.abs;function Sn(n,t,i){return U(n-t)<i}function En(n,t,i,r){var o=Y(t,i),t=wn(t,i);return r?o<n&&n<t:o<=n&&n<=t}function q(n,t,i){var r=Y(t,i),t=wn(t,i);return Y(wn(r,n),t)}function Ln(n){return(0<n)-(n<0)}function On(t,n){return g(n,function(n){t=t.replace("%s",""+n)}),t}function An(n){return n<10?"0"+n:""+n}var _n={};function zn(){var c=[];function i(n,i,r){g(n,function(t){t&&g(i,function(n){n.split(" ").forEach(function(n){n=n.split(".");r(t,n[0],n[1])})})})}return{bind:function(n,t,u,e){i(n,t,function(n,t,i){var r="addEventListener"in n,o=r?n.removeEventListener.bind(n,t,u,e):n.removeListener.bind(n,u);r?n.addEventListener(t,u,e):n.addListener(u),c.push([n,t,i,u,o])})},unbind:function(n,t,o){i(n,t,function(t,i,r){c=c.filter(function(n){return!!(n[0]!==t||n[1]!==i||n[2]!==r||o&&n[3]!==o)||(n[4](),!1)})})},dispatch:function(n,t,i){var r;return"function"==typeof CustomEvent?r=new CustomEvent(t,{bubbles:!0,detail:i}):(r=document.createEvent("CustomEvent")).initCustomEvent(t,!0,!1,i),n.dispatchEvent(r),r},destroy:function(){c.forEach(function(n){n[4]()}),D(c)}}}var B="mounted",H="move",Dn="moved",Mn="click",Pn="active",In="inactive",Rn="visible",Cn="hidden",J="refresh",K="updated",jn="resize",Nn="resized",Tn="scroll",V="scrolled",a="destroy",Gn="navigation:mounted",Fn="autoplay:play",Xn="autoplay:pause",Wn="lazyload:loaded",Yn="sk",Un="sh";function Q(n){var i=n?n.event.bus:document.createDocumentFragment(),r=zn();return n&&n.event.on(a,r.destroy),an(r,{bus:i,on:function(n,t){r.bind(i,y(n).join(" "),function(n){t.apply(t,e(n.detail)?n.detail:[])})},off:R(r.unbind,i),emit:function(n){r.dispatch(i,n,o(arguments,1))}})}function qn(t,n,i,r){var o,u,e=Date.now,c=0,f=!0,a=0;function s(){if(!f){if(c=t?Y((e()-o)/t,1):1,i&&i(c),1<=c&&(n(),o=e(),r&&++a>=r))return l();u=h(s)}}function l(){f=!0}function d(){u&&cancelAnimationFrame(u),f=!(u=c=0)}return{start:function(n){n||d(),o=e()-(n?c*t:0),f=!1,u=h(s)},rewind:function(){o=e(),c=0,i&&i(c)},pause:l,cancel:d,set:function(n){t=n},isPaused:function(){return f}}}function s(n){var t=n;return{set:function(n){t=n},is:function(n){return b(y(n),t)}}}var n="Arrow",Bn=n+"Left",Hn=n+"Right",t=n+"Up",n=n+"Down",Jn="ttb",l={width:["height"],left:["top","right"],right:["bottom","left"],x:["y"],X:["Y"],Y:["X"],ArrowLeft:[t,Hn],ArrowRight:[n,Bn]};var Z="role",$="tabindex",i="aria-",Kn=i+"controls",Vn=i+"current",Qn=i+"selected",nn=i+"label",Zn=i+"labelledby",$n=i+"hidden",nt=i+"orientation",tt=i+"roledescription",it=i+"live",rt=i+"busy",ot=i+"atomic",ut=[Z,$,"disabled",Kn,Vn,nn,Zn,$n,nt,tt],i=yn+"__",et=yn,ct=i+"track",ft=i+"list",at=i+"slide",st=at+"--clone",lt=at+"__container",dt=i+"arrows",vt=i+"arrow",ht=vt+"--prev",pt=vt+"--next",gt=i+"pagination",mt=gt+"__page",yt=i+"progress"+"__bar",bt=i+"toggle",wt=i+"sr",tn="is-active",xt="is-prev",kt="is-next",St="is-visible",Et="is-loading",Lt="is-focus-in",Ot="is-overflow",At=[tn,St,xt,kt,Et,Lt,Ot];var _t="touchstart mousedown",zt="touchmove mousemove",Dt="touchend touchcancel mouseup click";var Mt="slide",Pt="loop",It="fade";function Rt(o,r,t,u){var e,n=Q(o),i=n.on,c=n.emit,f=n.bind,a=o.Components,s=o.root,l=o.options,d=l.isNavigation,v=l.updateOnMove,h=l.i18n,p=l.pagination,g=l.slideFocus,m=a.Direction.resolve,y=z(u,"style"),b=z(u,nn),w=-1<t,x=fn(u,"."+lt);function k(){var n=o.splides.map(function(n){n=n.splide.Components.Slides.getAt(r);return n?n.slide.id:""}).join(" ");I(u,nn,On(h.slideX,(w?t:r)+1)),I(u,Kn,n),I(u,Z,g?"button":""),g&&P(u,tt)}function S(){e||E()}function E(){var n,t,i;e||(n=o.index,(i=L())!==vn(u,tn)&&(A(u,tn,i),I(u,Vn,d&&i||""),c(i?Pn:In,O)),i=function(){if(o.is(It))return L();var n=N(a.Elements.track),t=N(u),i=m("left",!0),r=m("right",!0);return xn(n[i])<=kn(t[i])&&xn(t[r])<=kn(n[r])}(),t=!i&&(!L()||w),o.state.is([G,rn])||I(u,$n,t||""),I(gn(u,l.focusableNodes||""),$,t?-1:""),g&&I(u,$,t?-1:0),i!==vn(u,St)&&(A(u,St,i),c(i?Rn:Cn,O)),i||document.activeElement!==u||(t=a.Slides.getAt(o.index))&&dn(t.slide),A(u,xt,r===n-1),A(u,kt,r===n+1))}function L(){var n=o.index;return n===r||l.cloneStatus&&n===t}var O={index:r,slideIndex:t,slide:u,container:x,isClone:w,mount:function(){w||(u.id=s.id+"-slide"+An(r+1),I(u,Z,p?"tabpanel":"group"),I(u,tt,h.slide),I(u,nn,b||On(h.slideLabel,[r+1,o.length]))),f(u,"click",R(c,Mn,O)),f(u,"keydown",R(c,Yn,O)),i([Dn,Un,V],E),i(Gn,k),v&&i(H,S)},destroy:function(){e=!0,n.destroy(),X(u,At),P(u,ut),I(u,"style",y),I(u,nn,b||"")},update:E,style:function(n,t,i){_(i&&x||u,n,t)},isWithin:function(n,t){return n=U(n-r),(n=w||!l.rewind&&!o.is(Pt)?n:Y(n,o.length-n))<=t}};return O}var Ct=f+"-interval";var jt={passive:!1,capture:!0};var Nt={Spacebar:" ",Right:Hn,Left:Bn,Up:t,Down:n};function Tt(n){return n=C(n)?n:n.key,Nt[n]||n}var Gt="keydown";var Ft=f+"-lazy",Xt=Ft+"-srcset",Wt="["+Ft+"], ["+Xt+"]";var Yt=[" ","Enter"];var Ut=Object.freeze({__proto__:null,Media:function(r,n,o){var u=r.state,t=o.breakpoints||{},e=o.reducedMotion||{},i=zn(),c=[];function f(n){n&&i.destroy()}function a(n,t){t=matchMedia(t);i.bind(t,"change",s),c.push([n,t])}function s(){var n=u.is(7),t=o.direction,i=c.reduce(function(n,t){return d(n,t[1].matches?t[0]:{})},{});sn(o),l(i),o.destroy?r.destroy("completely"===o.destroy):n?(f(!0),r.mount()):t!==o.direction&&r.refresh()}function l(n,t,i){d(o,n),t&&d(Object.getPrototypeOf(o),n),!i&&u.is(1)||r.emit(K,o)}return{setup:function(){var i="min"===o.mediaQuery;E(t).sort(function(n,t){return i?+n-+t:+t-+n}).forEach(function(n){a(t[n],"("+(i?"min":"max")+"-width:"+n+"px)")}),a(e,v),s()},destroy:f,reduce:function(n){matchMedia(v).matches&&(n?d(o,e):sn(o,E(e)))},set:l}},Direction:function(n,t,o){return{resolve:function(n,t,i){var r="rtl"!==(i=i||o.direction)||t?i===Jn?0:-1:1;return l[n]&&l[n][r]||n.replace(/width|left|right/i,function(n,t){n=l[n.toLowerCase()][r]||n;return 0<t?n.charAt(0).toUpperCase()+n.slice(1):n})},orient:function(n){return n*("rtl"===o.direction?1:-1)}}},Elements:function(n,t,i){var r,o,u,e=Q(n),c=e.on,f=e.bind,a=n.root,s=i.i18n,l={},d=[],v=[],h=[];function p(){r=y("."+ct),o=fn(r,"."+ft),bn(r&&o,"A track/list element is missing."),k(d,S(o,"."+at+":not(."+st+")")),w({arrows:dt,pagination:gt,prev:ht,next:pt,bar:yt,toggle:bt},function(n,t){l[t]=y("."+n)}),an(l,{root:a,track:r,list:o,slides:d});var n=a.id||function(n){return""+n+An(_n[n]=(_n[n]||0)+1)}(yn),t=i.role;a.id=n,r.id=r.id||n+"-track",o.id=o.id||n+"-list",!z(a,Z)&&"SECTION"!==a.tagName&&t&&I(a,Z,t),I(a,tt,s.carousel),I(o,Z,"presentation"),m()}function g(n){var t=ut.concat("style");D(d),X(a,v),X(r,h),P([r,o],t),P(a,n?t:["style",tt])}function m(){X(a,v),X(r,h),v=b(et),h=b(ct),M(a,v),M(r,h),I(a,nn,i.label),I(a,Zn,i.labelledby)}function y(n){n=pn(a,n);return n&&function(n,t){if(x(n.closest))return n.closest(t);for(var i=n;i&&1===i.nodeType&&!cn(i,t);)i=i.parentElement;return i}(n,"."+et)===a?n:void 0}function b(n){return[n+"--"+i.type,n+"--"+i.direction,i.drag&&n+"--draggable",i.isNavigation&&n+"--nav",n===et&&tn]}return an(l,{setup:p,mount:function(){c(J,g),c(J,p),c(K,m),f(document,_t+" keydown",function(n){u="keydown"===n.type},{capture:!0}),f(a,"focusin",function(){A(a,Lt,!!u)})},destroy:g})},Slides:function(r,o,u){var n=Q(r),t=n.on,e=n.emit,c=n.bind,f=(n=o.Elements).slides,a=n.list,s=[];function i(){f.forEach(function(n,t){d(n,t,-1)})}function l(){h(function(n){n.destroy()}),D(s)}function d(n,t,i){t=Rt(r,t,i,n);t.mount(),s.push(t),s.sort(function(n,t){return n.index-t.index})}function v(n){return n?p(function(n){return!n.isClone}):s}function h(n,t){v(t).forEach(n)}function p(t){return s.filter(x(t)?t:function(n){return C(t)?cn(n.slide,t):b(y(t),n.index)})}return{mount:function(){i(),t(J,l),t(J,i)},destroy:l,update:function(){h(function(n){n.update()})},register:d,get:v,getIn:function(n){var t=o.Controller,i=t.toIndex(n),r=t.hasFocus()?1:u.perPage;return p(function(n){return En(n.index,i,i+r-1)})},getAt:function(n){return p(n)[0]},add:function(n,o){g(n,function(n){var t,i,r;m(n=C(n)?hn(n):n)&&((t=f[o])?O(n,t):L(a,n),M(n,u.classes.slide),t=n,i=R(e,jn),t=gn(t,"img"),(r=t.length)?t.forEach(function(n){c(n,"load error",function(){--r||i()})}):i())}),e(J)},remove:function(n){T(p(n).map(function(n){return n.slide})),e(J)},forEach:h,filter:p,style:function(t,i,r){h(function(n){n.style(t,i,r)})},getLength:function(n){return(n?f:s).length},isEnough:function(){return s.length>u.perPage}}},Layout:function(t,n,i){var r,o,u,e=(a=Q(t)).on,c=a.bind,f=a.emit,a=n.Slides,s=n.Direction.resolve,l=(n=n.Elements).root,d=n.track,v=n.list,h=a.getAt,p=a.style;function g(){r=i.direction===Jn,_(l,"maxWidth",W(i.width)),_(d,s("paddingLeft"),y(!1)),_(d,s("paddingRight"),y(!0)),m(!0)}function m(n){var t=N(l);!n&&o.width===t.width&&o.height===t.height||(_(d,"height",function(){var n="";r&&(bn(n=b(),"height or heightRatio is missing."),n="calc("+n+" - "+y(!1)+" - "+y(!0)+")");return n}()),p(s("marginRight"),W(i.gap)),p("width",i.autoWidth?null:W(i.fixedWidth)||(r?"":w())),p("height",W(i.fixedHeight)||(r?i.autoHeight?null:w():b()),!0),o=t,f(Nn),u!==(u=O())&&(A(l,Ot,u),f("overflow",u)))}function y(n){var t=i.padding,n=s(n?"right":"left");return t&&W(t[n]||(un(t)?0:t))||"0px"}function b(){return W(i.height||N(v).width*i.heightRatio)}function w(){var n=W(i.gap);return"calc((100%"+(n&&" + "+n)+")/"+(i.perPage||1)+(n&&" - "+n)+")"}function x(){return N(v)[s("width")]}function k(n,t){n=h(n||0);return n?N(n.slide)[s("width")]+(t?0:L()):0}function S(n,t){var i,n=h(n);return n?(n=N(n.slide)[s("right")],i=N(v)[s("left")],U(n-i)+(t?0:L())):0}function E(n){return S(t.length-1)-S(0)+k(0,n)}function L(){var n=h(0);return n&&parseFloat(_(n.slide,s("marginRight")))||0}function O(){return t.is(It)||E(!0)>x()}return{mount:function(){var n,t,i;g(),c(window,"resize load",(n=R(f,jn),i=qn(t||0,n,null,1),function(){i.isPaused()&&i.start()})),e([K,J],g),e(jn,m)},resize:m,listSize:x,slideSize:k,sliderSize:E,totalSize:S,getPadding:function(n){return parseFloat(_(d,s("padding"+(n?"Right":"Left"))))||0},isOverflow:O}},Clones:function(c,i,f){var t,r=Q(c),n=r.on,a=i.Elements,s=i.Slides,o=i.Direction.resolve,l=[];function u(){if(n(J,d),n([K,jn],v),t=h()){var o=t,u=s.get().slice(),e=u.length;if(e){for(;u.length<o;)k(u,u);k(u.slice(-o),u.slice(0,o)).forEach(function(n,t){var i=t<o,r=function(n,t){n=n.cloneNode(!0);return M(n,f.classes.clone),n.id=c.root.id+"-clone"+An(t+1),n}(n.slide,t);i?O(r,u[0].slide):L(a.list,r),k(l,r),s.register(r,t-o+(i?0:e),n.index)})}i.Layout.resize(!0)}}function d(){e(),u()}function e(){T(l),D(l),r.destroy()}function v(){var n=h();t!==n&&(t<n||!n)&&r.emit(J)}function h(){var n,t=f.clones;return c.is(Pt)?en(t)&&(t=(n=f[o("fixedWidth")]&&i.Layout.slideSize(0))&&kn(N(a.track)[o("width")]/n)||f[o("autoWidth")]&&c.length||2*f.perPage):t=0,t}return{mount:u,destroy:e}},Move:function(r,c,o){var e,n=Q(r),t=n.on,f=n.emit,a=r.state.set,u=(n=c.Layout).slideSize,i=n.getPadding,s=n.totalSize,l=n.listSize,d=n.sliderSize,v=(n=c.Direction).resolve,h=n.orient,p=(n=c.Elements).list,g=n.track;function m(){c.Controller.isBusy()||(c.Scroll.cancel(),y(r.index),c.Slides.update())}function y(n){b(S(n,!0))}function b(n,t){r.is(It)||(t=t?n:function(n){{var t,i;r.is(Pt)&&(t=k(n),i=t>c.Controller.getEnd(),(t<0||i)&&(n=w(n,i)))}return n}(n),_(p,"transform","translate"+v("X")+"("+t+"px)"),n!==t&&f(Un))}function w(n,t){var i=n-L(t),r=d();return n-=h(r*(kn(U(i)/r)||1))*(t?1:-1)}function x(){b(E(),!0),e.cancel()}function k(n){for(var t=c.Slides.get(),i=0,r=1/0,o=0;o<t.length;o++){var u=t[o].index,e=U(S(u,!0)-n);if(!(e<=r))break;r=e,i=u}return i}function S(n,t){var i=h(s(n-1)-(n=n,"center"===(i=o.focus)?(l()-u(n,!0))/2:+i*u(n)||0));return t?(n=i,n=o.trimSpace&&r.is(Mt)?q(n,0,h(d(!0)-l())):n):i}function E(){var n=v("left");return N(p)[n]-N(g)[n]+h(i(!1))}function L(n){return S(n?c.Controller.getEnd():0,!!o.trimSpace)}return{mount:function(){e=c.Transition,t([B,Nn,K,J],m)},move:function(n,t,i,r){var o,u;n!==t&&(o=i<n,u=h(w(E(),o)),o?0<=u:u<=p[v("scrollWidth")]-N(g)[v("width")])&&(x(),b(w(E(),i<n),!0)),a(G),f(H,t,i,n),e.start(t,function(){a(3),f(Dn,t,i,n),r&&r()})},jump:y,translate:b,shift:w,cancel:x,toIndex:k,toPosition:S,getPosition:E,getLimit:L,exceededLimit:function(n,t){t=en(t)?E():t;var i=!0!==n&&h(t)<h(L(!1)),n=!1!==n&&h(t)>h(L(!0));return i||n},reposition:m}},Controller:function(o,u,e){var c,f,a,s,n=Q(o),t=n.on,i=n.emit,l=u.Move,d=l.getPosition,r=l.getLimit,v=l.toPosition,h=(n=u.Slides).isEnough,p=n.getLength,g=e.omitEnd,m=o.is(Pt),y=o.is(Mt),b=R(L,!1),w=R(L,!0),x=e.start||0,k=x;function S(){f=p(!0),a=e.perMove,s=e.perPage,c=_();var n=q(x,0,g?c:f-1);n!==x&&(x=n,l.reposition())}function E(){c!==_()&&i("ei")}function L(n,t){var i=a||(P()?1:s),i=O(x+i*(n?-1:1),x,!(a||P()));return-1===i&&y&&!Sn(d(),r(!n),1)?n?0:c:t?i:A(i)}function O(n,t,i){var r;return h()||P()?((r=function(n){if(y&&"move"===e.trimSpace&&n!==x)for(var t=d();t===v(n,!0)&&En(n,0,o.length-1,!e.rewind);)n<x?--n:++n;return n}(n))!==n&&(t=n,n=r,i=!1),n<0||c<n?n=a||!En(0,n,t,!0)&&!En(c,t,n,!0)?m?i?n<0?-(f%s||s):f:n:e.rewind?n<0?c:0:-1:z(D(n)):i&&n!==t&&(n=z(D(t)+(n<t?-1:1)))):n=-1,n}function A(n){return m?(n+f)%f||0:n}function _(){for(var n=f-(P()||m&&a?1:s);g&&0<n--;)if(v(f-1,!0)!==v(n,!0)){n++;break}return q(n,0,f-1)}function z(n){return q(P()?n:s*n,0,c)}function D(n){return P()?Y(n,c):xn((c<=n?f-1:n)/s)}function M(n){n!==x&&(k=x,x=n)}function P(){return!en(e.focus)||e.isNavigation}function I(){return o.state.is([G,rn])&&!!e.waitForTransition}return{mount:function(){S(),t([K,J,"ei"],S),t(Nn,E)},go:function(n,t,i){var r;I()||-1<(r=A(n=function(n){var t=x;{var i,r;C(n)?(r=n.match(/([+\-<>])(\d+)?/)||[],i=r[1],r=r[2],"+"===i||"-"===i?t=O(x+ +(""+i+(+r||1)),x):">"===i?t=r?z(+r):b(!0):"<"===i&&(t=w(!0))):t=m?n:q(n,0,c)}return t}(n)))&&(t||r!==x)&&(M(r),l.move(n,r,k,i))},scroll:function(n,t,i,r){u.Scroll.scroll(n,t,i,function(){var n=A(l.toIndex(d()));M(g?Y(n,c):n),r&&r()})},getNext:b,getPrev:w,getAdjacent:L,getEnd:_,setIndex:M,getIndex:function(n){return n?k:x},toIndex:z,toPage:D,toDest:function(n){return n=l.toIndex(n),y?q(n,0,c):n},hasFocus:P,isBusy:I}},Arrows:function(o,n,t){var i,r,u=Q(o),e=u.on,c=u.bind,f=u.emit,a=t.classes,s=t.i18n,l=n.Elements,d=n.Controller,v=l.arrows,h=l.track,p=v,g=l.prev,m=l.next,y={};function b(){var n=t.arrows;!n||g&&m||(p=v||j("div",a.arrows),g=S(!0),m=S(!1),i=!0,L(p,[g,m]),v||O(p,h)),g&&m&&(an(y,{prev:g,next:m}),ln(p,n?"":"none"),M(p,r=dt+"--"+t.direction),n&&(e([B,Dn,J,V,"ei"],E),c(m,"click",R(k,">")),c(g,"click",R(k,"<")),E(),I([g,m],Kn,h.id),f("arrows:mounted",g,m))),e(K,w)}function w(){x(),b()}function x(){u.destroy(),X(p,r),i?(T(v?[g,m]:p),g=m=null):P([g,m],ut)}function k(n){d.go(n,!0)}function S(n){return hn('<button class="'+a.arrow+" "+(n?a.prev:a.next)+'" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="'+(t.arrowPath||"m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z")+'" />')}function E(){var n,t,i,r;g&&m&&(r=o.index,n=d.getPrev(),t=d.getNext(),i=-1<n&&r<n?s.last:s.prev,r=-1<t&&t<r?s.first:s.next,g.disabled=n<0,m.disabled=t<0,I(g,nn,i),I(m,nn,r),f("arrows:updated",g,m,n,t))}return{arrows:y,mount:b,destroy:x,update:E}},Autoplay:function(n,t,i){var r,o,u=Q(n),e=u.on,c=u.bind,f=u.emit,a=qn(i.interval,n.go.bind(n,">"),function(n){var t=l.bar;t&&_(t,"width",100*n+"%"),f("autoplay:playing",n)}),s=a.isPaused,l=t.Elements,d=(u=t.Elements).root,v=u.toggle,h=i.autoplay,p="pause"===h;function g(){s()&&t.Slides.isEnough()&&(a.start(!i.resetProgress),o=r=p=!1,b(),f(Fn))}function m(n){p=!!(n=void 0===n?!0:n),b(),s()||(a.pause(),f(Xn))}function y(){p||(r||o?m(!1):g())}function b(){v&&(A(v,tn,!p),I(v,nn,i.i18n[p?"play":"pause"]))}function w(n){n=t.Slides.getAt(n);a.set(n&&+z(n.slide,Ct)||i.interval)}return{mount:function(){h&&(i.pauseOnHover&&c(d,"mouseenter mouseleave",function(n){r="mouseenter"===n.type,y()}),i.pauseOnFocus&&c(d,"focusin focusout",function(n){o="focusin"===n.type,y()}),v&&c(v,"click",function(){p?g():m(!0)}),e([H,Tn,J],a.rewind),e(H,w),v&&I(v,Kn,l.track.id),p||g(),b())},destroy:a.cancel,play:g,pause:m,isPaused:s}},Cover:function(n,t,i){var r=Q(n).on;function o(i){t.Slides.forEach(function(n){var t=fn(n.container||n.slide,"img");t&&t.src&&u(i,t,n)})}function u(n,t,i){i.style("background",n?'center/cover no-repeat url("'+t.src+'")':"",!0),ln(t,n?"none":"")}return{mount:function(){i.cover&&(r(Wn,R(u,!0)),r([B,K,J],R(o,!0)))},destroy:R(o,!1)}},Scroll:function(n,c,u){var f,a,t=Q(n),i=t.on,s=t.emit,l=n.state.set,d=c.Move,v=d.getPosition,e=d.getLimit,h=d.exceededLimit,p=d.translate,g=n.is(Mt),m=1;function y(n,t,i,r,o){var u,e=v(),i=(x(),!i||g&&h()||(i=c.Layout.sliderSize(),u=Ln(n)*i*xn(U(n)/i)||0,n=d.toPosition(c.Controller.toDest(n%i))+u),Sn(e,n,1));m=1,t=i?0:t||wn(U(n-e)/1.5,800),a=r,f=qn(t,b,R(w,e,n,o),1),l(rn),s(Tn),f.start()}function b(){l(3),a&&a(),s(V)}function w(n,t,i,r){var o=v(),r=(n+(t-n)*(t=r,(n=u.easingFunc)?n(t):1-Math.pow(1-t,4))-o)*m;p(o+r),g&&!i&&h()&&(m*=.6,U(r)<10&&y(e(h(!0)),600,!1,a,!0))}function x(){f&&f.cancel()}function r(){f&&!f.isPaused()&&(x(),b())}return{mount:function(){i(H,x),i([K,J],r)},destroy:x,scroll:y,cancel:r}},Drag:function(e,o,c){var f,t,u,a,s,l,d,v,n=Q(e),i=n.on,h=n.emit,p=n.bind,g=n.unbind,m=e.state,y=o.Move,b=o.Scroll,w=o.Controller,x=o.Elements.track,k=o.Media.reduce,r=(n=o.Direction).resolve,S=n.orient,E=y.getPosition,L=y.exceededLimit,O=!1;function j(){var n=c.drag;C(!n),a="free"===n}function N(n){var t,i,r;l=!1,d||(t=R(n),i=n.target,r=c.noDrag,cn(i,"."+mt+", ."+vt)||r&&cn(i,r)||!t&&n.button||(w.isBusy()?F(n,!0):(v=t?x:window,s=m.is([G,rn]),u=null,p(v,zt,A,jt),p(v,Dt,_,jt),y.cancel(),b.cancel(),z(n))))}function A(n){var t,i,r,o,u;m.is(6)||(m.set(6),h("drag")),n.cancelable&&(s?(y.translate(f+D(n)/(O&&e.is(Mt)?5:1)),u=200<M(n),t=O!==(O=L()),(u||t)&&z(n),l=!0,h("dragging"),F(n)):U(D(u=n))>U(D(u,!0))&&(t=n,i=c.dragMinThreshold,r=un(i),o=r&&i.mouse||0,r=(r?i.touch:+i)||10,s=U(D(t))>(R(t)?r:o),F(n)))}function _(n){var t,i,r;m.is(6)&&(m.set(3),h("dragged")),s&&(i=function(n){return E()+Ln(n)*Y(U(n)*(c.flickPower||600),a?1/0:o.Layout.listSize()*(c.flickMaxPages||1))}(t=function(n){if(e.is(Pt)||!O){var t=M(n);if(t&&t<200)return D(n)/t}return 0}(t=n)),r=c.rewind&&c.rewindByDrag,k(!1),a?w.scroll(i,0,c.snap):e.is(It)?w.go(S(Ln(t))<0?r?"<":"-":r?">":"+"):e.is(Mt)&&O&&r?w.go(L(!0)?">":"<"):w.go(w.toDest(i),!0),k(!0),F(n)),g(v,zt,A),g(v,Dt,_),s=!1}function T(n){!d&&l&&F(n,!0)}function z(n){u=t,t=n,f=E()}function D(n,t){return I(n,t)-I(P(n),t)}function M(n){return mn(n)-mn(P(n))}function P(n){return t===n&&u||t}function I(n,t){return(R(n)?n.changedTouches[0]:n)["page"+r(t?"Y":"X")]}function R(n){return"undefined"!=typeof TouchEvent&&n instanceof TouchEvent}function C(n){d=n}return{mount:function(){p(x,zt,on,jt),p(x,Dt,on,jt),p(x,_t,N,jt),p(x,"click",T,{capture:!0}),p(x,"dragstart",F),i([B,K],j)},disable:C,isDragging:function(){return s}}},Keyboard:function(t,n,i){var r,o,u=Q(t),e=u.on,c=u.bind,f=u.unbind,a=t.root,s=n.Direction.resolve;function l(){var n=i.keyboard;n&&(r="global"===n?window:a,c(r,Gt,h))}function d(){f(r,Gt)}function v(){var n=o;o=!0,p(function(){o=n})}function h(n){o||((n=Tt(n))===s(Bn)?t.go("<"):n===s(Hn)&&t.go(">"))}return{mount:function(){l(),e(K,d),e(K,l),e(H,v)},destroy:d,disable:function(n){o=n}}},LazyLoad:function(i,n,o){var t=Q(i),r=t.on,u=t.off,e=t.bind,c=t.emit,f="sequential"===o.lazyLoad,a=[Dn,V],s=[];function l(){D(s),n.Slides.forEach(function(r){gn(r.slide,Wt).forEach(function(n){var t=z(n,Ft),i=z(n,Xt);t===n.src&&i===n.srcset||(t=o.classes.spinner,t=fn(i=n.parentElement,"."+t)||j("span",t,i),s.push([n,r,t]),n.src||ln(n,"none"))})}),(f?p:(u(a),r(a,d),d))()}function d(){(s=s.filter(function(n){var t=o.perPage*((o.preloadPages||1)+1)-1;return!n[1].isWithin(i.index,t)||v(n)})).length||u(a)}function v(n){var t=n[0];M(n[1].slide,Et),e(t,"load error",R(h,n)),I(t,"src",z(t,Ft)),I(t,"srcset",z(t,Xt)),P(t,Ft),P(t,Xt)}function h(n,t){var i=n[0],r=n[1];X(r.slide,Et),"error"!==t.type&&(T(n[2]),ln(i,""),c(Wn,i,r),c(jn)),f&&p()}function p(){s.length&&v(s.shift())}return{mount:function(){o.lazyLoad&&(l(),r(J,l))},destroy:R(D,s),check:d}},Pagination:function(l,n,d){var v,h,t=Q(l),p=t.on,g=t.emit,m=t.bind,y=n.Slides,b=n.Elements,w=n.Controller,x=w.hasFocus,r=w.getIndex,e=w.go,c=n.Direction.resolve,k=b.pagination,S=[];function E(){v&&(T(k?o(v.children):v),X(v,h),D(S),v=null),t.destroy()}function L(n){e(">"+n,!0)}function O(n,t){var i=S.length,r=Tt(t),o=A(),u=-1,o=(r===c(Hn,!1,o)?u=++n%i:r===c(Bn,!1,o)?u=(--n+i)%i:"Home"===r?u=0:"End"===r&&(u=i-1),S[u]);o&&(dn(o.button),e(">"+u),F(t,!0))}function A(){return d.paginationDirection||d.direction}function _(n){return S[w.toPage(n)]}function z(){var n,t=_(r(!0)),i=_(r());t&&(X(n=t.button,tn),P(n,Qn),I(n,$,-1)),i&&(M(n=i.button,tn),I(n,Qn,!0),I(n,$,"")),g("pagination:updated",{list:v,items:S},t,i)}return{items:S,mount:function n(){E(),p([K,J,"ei"],n);var t=d.pagination;if(k&&ln(k,t?"":"none"),t){p([H,Tn,V],z);var t=l.length,i=d.classes,r=d.i18n,o=d.perPage,u=x()?w.getEnd()+1:kn(t/o);M(v=k||j("ul",i.pagination,b.track.parentElement),h=gt+"--"+A()),I(v,Z,"tablist"),I(v,nn,r.select),I(v,nt,A()===Jn?"vertical":"");for(var e=0;e<u;e++){var c=j("li",null,v),f=j("button",{class:i.page,type:"button"},c),a=y.getIn(e).map(function(n){return n.slide.id}),s=!x()&&1<o?r.pageX:r.slideX;m(f,"click",R(L,e)),d.paginationKeyboard&&m(f,"keydown",R(O,e)),I(c,Z,"presentation"),I(f,Z,"tab"),I(f,Kn,a.join(" ")),I(f,nn,On(s,e+1)),I(f,$,-1),S.push({li:c,button:f,page:e})}z(),g("pagination:mounted",{list:v,items:S},_(l.index))}},destroy:E,getAt:_,update:z}},Sync:function(i,n,t){var r=t.isNavigation,o=t.slideFocus,u=[];function e(){var n,t;i.splides.forEach(function(n){n.isParent||(f(i,n.splide),f(n.splide,i))}),r&&(n=Q(i),(t=n.on)(Mn,s),t(Yn,l),t([B,K],a),u.push(n),n.emit(Gn,i.splides))}function c(){u.forEach(function(n){n.destroy()}),D(u)}function f(n,r){n=Q(n);n.on(H,function(n,t,i){r.go(r.is(Pt)?i:n)}),u.push(n)}function a(){I(n.Elements.list,nt,t.direction===Jn?"vertical":"")}function s(n){i.go(n.index)}function l(n,t){b(Yt,Tt(t))&&(s(n),F(t))}return{setup:R(n.Media.set,{slideFocus:en(o)?r:o},!0),mount:e,destroy:c,remount:function(){c(),e()}}},Wheel:function(e,c,f){var n=Q(e).bind,a=0;function t(n){var t,i,r,o,u;n.cancelable&&(t=(u=n.deltaY)<0,i=mn(n),r=f.wheelMinThreshold||0,o=f.wheelSleep||0,U(u)>r&&o<i-a&&(e.go(t?"<":">"),a=i),u=t,f.releaseWheel&&!e.state.is(G)&&-1===c.Controller.getAdjacent(u)||F(n))}return{mount:function(){f.wheel&&n(c.Elements.track,"wheel",t,jt)}}},Live:function(n,t,i){var r=Q(n).on,o=t.Elements.track,u=i.live&&!i.isNavigation,e=j("span",wt),c=qn(90,R(f,!1));function f(n){I(o,rt,n),n?(L(o,e),c.start()):(T(e),c.cancel())}function a(n){u&&I(o,it,n?"off":"polite")}return{mount:function(){u&&(a(!t.Autoplay.isPaused()),I(o,ot,!0),e.textContent="…",r(Fn,R(a,!0)),r(Xn,R(a,!1)),r([Dn,V],R(f,!0)))},disable:a,destroy:function(){P(o,[it,ot,rt]),T(e)}}}}),qt={type:"slide",role:"region",speed:400,perPage:1,cloneStatus:!0,arrows:!0,pagination:!0,paginationKeyboard:!0,interval:5e3,pauseOnHover:!0,pauseOnFocus:!0,resetProgress:!0,easing:"cubic-bezier(0.25, 1, 0.5, 1)",drag:!0,direction:"ltr",trimSpace:!0,focusableNodes:"a, button, textarea, input, select, iframe",live:!0,classes:{slide:at,clone:st,arrows:dt,arrow:vt,prev:ht,next:pt,pagination:gt,page:mt,spinner:i+"spinner"},i18n:{prev:"Previous slide",next:"Next slide",first:"Go to first slide",last:"Go to last slide",slideX:"Go to slide %s",pageX:"Go to page %s",play:"Start autoplay",pause:"Pause autoplay",carousel:"carousel",slide:"slide",select:"Select a slide to show",slideLabel:"%s of %s"},reducedMotion:{speed:0,rewindSpeed:0,autoplay:"pause"}};function Bt(n,t,i){var r=t.Slides;function o(){r.forEach(function(n){n.style("transform","translateX(-"+100*n.index+"%)")})}return{mount:function(){Q(n).on([B,J],o)},start:function(n,t){r.style("transition","opacity "+i.speed+"ms "+i.easing),p(t)},cancel:on}}function Ht(u,n,e){var c,f=n.Move,a=n.Controller,s=n.Scroll,t=n.Elements.list,l=R(_,t,"transition");function i(){l(""),s.cancel()}return{mount:function(){Q(u).bind(t,"transitionend",function(n){n.target===t&&c&&(i(),c())})},start:function(n,t){var i=f.toPosition(n,!0),r=f.getPosition(),o=function(n){var t=e.rewindSpeed;if(u.is(Mt)&&t){var i=a.getIndex(!0),r=a.getEnd();if(0===i&&r<=n||r<=i&&0===n)return t}return e.speed}(n);1<=U(i-r)&&1<=o?e.useScroll?s.scroll(i,o,!1,t):(l("transform "+o+"ms "+e.easing),f.translate(i,!0),c=t):(f.jump(n),t())},cancel:i}}t=function(){function i(n,t){this.event=Q(),this.Components={},this.state=s(1),this.splides=[],this.n={},this.t={};n=C(n)?pn(document,n):n;bn(n,n+" is invalid."),t=d({label:z(this.root=n,nn)||"",labelledby:z(n,Zn)||""},qt,i.defaults,t||{});try{d(t,JSON.parse(z(n,f)))}catch(n){bn(!1,"Invalid JSON")}this.n=Object.create(d({},t))}var n=i.prototype;return n.mount=function(n,t){var i=this,r=this.state,o=this.Components;return bn(r.is([1,7]),"Already mounted!"),r.set(1),this.i=o,this.r=t||this.r||(this.is(It)?Bt:Ht),this.t=n||this.t,w(an({},Ut,this.t,{Transition:this.r}),function(n,t){n=n(i,o,i.n);(o[t]=n).setup&&n.setup()}),w(o,function(n){n.mount&&n.mount()}),this.emit(B),M(this.root,"is-initialized"),r.set(3),this.emit("ready"),this},n.sync=function(n){return this.splides.push({splide:n}),n.splides.push({splide:this,isParent:!0}),this.state.is(3)&&(this.i.Sync.remount(),n.Components.Sync.remount()),this},n.go=function(n){return this.i.Controller.go(n),this},n.on=function(n,t){return this.event.on(n,t),this},n.off=function(n){return this.event.off(n),this},n.emit=function(n){var t;return(t=this.event).emit.apply(t,[n].concat(o(arguments,1))),this},n.add=function(n,t){return this.i.Slides.add(n,t),this},n.remove=function(n){return this.i.Slides.remove(n),this},n.is=function(n){return this.n.type===n},n.refresh=function(){return this.emit(J),this},n.destroy=function(t){void 0===t&&(t=!0);var n=this.event,i=this.state;return i.is(1)?Q(this).on("ready",this.destroy.bind(this,t)):(w(this.i,function(n){n.destroy&&n.destroy(t)},!0),n.emit(a),n.destroy(),t&&D(this.splides),i.set(7)),this},Jt(i,[{key:"options",get:function(){return this.n},set:function(n){this.i.Media.set(n,!0,!0)}},{key:"length",get:function(){return this.i.Slides.getLength(!0)}},{key:"index",get:function(){return this.i.Controller.getIndex()}}]),i}();return t.defaults={},t.STATES=r,t},"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(n="undefined"!=typeof globalThis?globalThis:n||self).Splide=t();
//# sourceMappingURL=splide.min.js.map

;(function influencerCarousel() {
  const sections = Array.from(document.querySelectorAll('.influencers'))
  if (sections === null) {
    return
  }

  // function onSlideClick(evt, quoteSplide, influencerSlide) {
  //   const { target } = evt
  //   const slideClass = '.glide__slide'
  //   const targetSlide = target.closest(slideClass)
  //   const targetIndex = Number(targetSlide.dataset.id)
  //   influencerSlide.go(`=${targetIndex}`)
  //   quoteSplide.go(`=${targetIndex}`)
  // }

  function onButtonClick(evt, direction, quoteSplide, influencerSlide) {
    quoteSplide.go(direction)
  }

  sections.forEach((section) => {
    const options = {
      arrows: false,
      type: 'loop',
      start: 0,
      keyboard: true,

      pagination: false,
      autoplay  : true,          // Enables auto-sliding
      interval  : 5000,          // Time between slides in milliseconds (3000 = 3 seconds)
      pauseOnHover: false   
    }
    const quoteSplide = new Splide('.influencers__quotes', {
      ...options,
      isNavigation: true,
      speed: 0,
      gap: 0,
      perPage: 1,
    })

    const influencersSplide = new Splide('.influencers__splide', {
      ...options,
      isNavigation: true,
      speed: 0,
      gap: 16,
      autoWidth: true,
      breakpoints: {
        960: {
          perView: 1,
        },
        1200: {
          perView: 2,
        },
      },
    })
    quoteSplide.sync(influencersSplide)
    quoteSplide.mount()
    influencersSplide.mount()
    const ArrowLeft = section.querySelector('.slider-button--prev')
    const ArrowRight = section.querySelector('.slider-button--next')
    ArrowLeft.addEventListener('click', (evt) =>
      onButtonClick(evt, '-1', quoteSplide)
    )
    ArrowRight.addEventListener('click', (evt) =>
      onButtonClick(evt, '+1', quoteSplide)
    )
  })
})()

;(function staticReviewCarousel() {
  const sections = Array.from(document.querySelectorAll('.static-reviews'))
  if (sections === null) {
    return
  }

  sections.forEach((section) => {
    const options = {
      arrows: true,
      type: 'loop',
      keyboard: true,
      pagination: false
    }
  
    const staticReview = new Splide('.static-reviews-splide', {
      ...options,
      isNavigation: false,
      speed: 0,
      gap: 16,
      perPage: 3,
      autoHeight: true,
      breakpoints: {
        750: {
          perPage: 1
        },
      },
    })
    staticReview.mount()
  })
})()
;(function featureCarousel() {
  const sections = Array.from(document.querySelectorAll('.features'))
  if (sections === null) {
    return
  }

  // function onSlideClick(evt, quoteSplide, featureSlide) {
  //   const { target } = evt
  //   const slideClass = '.glide__slide'
  //   const targetSlide = target.closest(slideClass)
  //   const targetIndex = Number(targetSlide.dataset.id)
  //   featureSlide.go(`=${targetIndex}`)
  //   quoteSplide.go(`=${targetIndex}`)
  // }

  function onButtonClick(evt, direction, quoteSplide, featureSlide) {
    quoteSplide.go(direction)
  }

  sections.forEach((section) => {
    const options = {
      arrows: false,
      start: 0,
      keyboard: true,

      pagination: false,
      interval  : 5000,          // Time between slides in milliseconds (3000 = 3 seconds)
      pauseOnHover: false   
    }
    const quoteSplide = new Splide('.features__quotes', {
      ...options,
      isNavigation: true,
      speed: 0,
      perPage: 1,
      breakpoints: {
        960: {
          perView: 1,
          gap: 0,
        },
        1200: {
          perView: 6,
        },
      },
    })

    const featuresSplide = new Splide('.features__splide', {
      ...options,
      isNavigation: true,
      speed: 0,
      breakpoints: {
        960: {
          perView: 1,
        },
        1200: {
          perView: 1,
        },
      },
    })
    quoteSplide.sync(featuresSplide)
    quoteSplide.mount()
    featuresSplide.mount()
    const ArrowLeft = section.querySelector('.slider-button--prev')
    const ArrowRight = section.querySelector('.slider-button--next')
    ArrowLeft.addEventListener('click', (evt) =>
      onButtonClick(evt, '-1', quoteSplide)
    )
    ArrowRight.addEventListener('click', (evt) =>
      onButtonClick(evt, '+1', quoteSplide)
    )
  })
})()

;(function staticReviewCarousel() {
  const sections = Array.from(document.querySelectorAll('.static-reviews'))
  if (sections === null) {
    return
  }

  sections.forEach((section) => {
    const options = {
      arrows: true,
      type: 'loop',
      keyboard: true,
      pagination: false
    }
  
    const staticReview = new Splide('.static-reviews-splide', {
      ...options,
      isNavigation: false,
      speed: 0,
      gap: 16,
      perPage: 3,
      autoHeight: true,
      breakpoints: {
        750: {
          perPage: 1
        },
      },
    })
    staticReview.mount()
  })
})()